import { render, staticRenderFns } from "./CreateAndAddProductToReceivings.vue?vue&type=template&id=9d296016"
import script from "./CreateAndAddProductToReceivings.vue?vue&type=script&lang=js"
export * from "./CreateAndAddProductToReceivings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports